
import {apiHttpClient} from "@/http/httpClient";
import type {
    Organization,
    OrganizationListModel,
    OrganizationListRequest
} from "@/models/administration/organization/organization";
import type {PaginationItems} from "@/models/pagination";

const ENDPOINT_LIST_ORGANIZATION = "Organization/List";
const ENDPOINT_GET_ORGANIZATION = "Organization/Get";
const ENDPOINT_UPDATE_ORGANIZATION = "Organization/Update";
const ENDPOINT_CREATE_ORGANIZATION = "Organization/Create";
const ENDPOINT_SETUP_DATAEXE_CONNECTION = "Organization/SetupDataExeConnection";
const ENDPOINT_CONSENT_URL = "Organization/GetConsentUrl";
const ENDPOINT_SYNC_ENTRA_USERS = "Organization/SyncEntraUsers";

export const syncEntraUsers = (organizationId: number) => {
    return apiHttpClient().post(`${ENDPOINT_SYNC_ENTRA_USERS}/${organizationId}`)
        .then(response => response)
        .catch(error => error);
}

export const listOrganizations = (request: OrganizationListRequest) => {
    return apiHttpClient().post<PaginationItems<OrganizationListModel>>(ENDPOINT_LIST_ORGANIZATION, request)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getOrganization = (id: number) => {
    return apiHttpClient().get<Organization>(`${ENDPOINT_GET_ORGANIZATION}/${id}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const createOrganization = (organization: Organization) => {
    return apiHttpClient().post(ENDPOINT_CREATE_ORGANIZATION, organization)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const updateOrganization = (organization: Organization) => {
    return apiHttpClient().put(ENDPOINT_UPDATE_ORGANIZATION, organization)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const setupDataExeConnection = (id: number) => {
    return apiHttpClient().post(`${ENDPOINT_SETUP_DATAEXE_CONNECTION}/${id}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

export const getConsentUrl = (organizationId: number) => {
    return apiHttpClient().get<{ url: string }>(`${ENDPOINT_CONSENT_URL}/${organizationId}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}
